import React from 'react'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useAuditRecord } from '../../../../../../shared/audit/history/audit-record-context'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { useApiFormAssetVersion, useApiFormPublishAssetVersion } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleTextarea } from '../../../../../../shared/form-simple/form-textarea'
import { ButtonSubmit } from '../../../../../../shared/form-simple/form-submit'
import { Menu, MenuDelete, MenuItem, MenuRecycle } from '../../../../../../shared/menu/menu'
import { IconCheck, IconDownload, IconEdit } from '../../../../../../shared/icon/icon'
import { useDownloadPresign } from '../../../../../../shared/download/hook'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { Delete } from '../../../../../../shared/page/page-delete'

export const PublishAssetVersionEdit = ({ parentURL }) => {
  const { assetVersionID } = useParamsInt()
  // this version's History ("Version N"), not the asset's
  useAuditRecord({ type: 'asset_versions', id: assetVersionID, role: { org: 'NODE' } })

  const { url } = useRouteMatch()

  const apiFormPublishAssetVersion = useApiFormPublishAssetVersion()

  const roleSysApp = useRoleSysApp()

  const { active, download } = useDownloadPresign()

  const handlePath = () => apiFormPublishAssetVersion.get(`${assetVersionID}`)

  const handleSetCurrent = async id => {
    await apiFormPublishAssetVersion.put(`${id}/current`)
    await apiFormPublishAssetVersion.get(`${assetVersionID}`)
  }

  const handleDownload = async id => {
    let presigned = await apiFormPublishAssetVersion.get(`${id}/presigned-download`)
    download(presigned.url)
  }

  const handleSubmit = async data => {
    await apiFormPublishAssetVersion.put(data.id, data)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuItem
        Icon={IconCheck}
        text="set current"
        onClick={() => handleSetCurrent(assetVersionID)}
        show={roleSysApp.accessUpdate}
        disabled={apiFormPublishAssetVersion.form.status !== 'complete'}
      />
      <MenuItem Icon={IconDownload} text="download" onClick={() => handleDownload(assetVersionID)} show={roleSysApp.accessRead} disabled={active} />
      <MenuDelete to={`${url}/${assetVersionID}/delete`} show={roleSysApp.accessDelete} />
      <MenuRecycle to={`${url}/${assetVersionID}/recycle`} show={roleSysApp.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormPublishAssetVersion.form.filename} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormPublishAssetVersion.form.filename} HeaderMenu={HeaderMenu}>
          <FormSimple state={apiFormPublishAssetVersion.form} onSubmit={handleSubmit} onRefresh={handlePath}>
            <FormSimpleText label="filename" name="filename" readonly />
            <FormSimpleText name="status" readonly />
            <FormSimpleTextarea label="notes" name="note" />
            <ButtonSubmit text="save version" />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:deleteID/delete`}>
        <Delete useApiForm={useApiFormAssetVersion} titleParam={'name'} successPath={parentURL} />
      </Route>
    </React.Fragment>
  )
}
